import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Login.css"; // Assuming you want to reuse some of the existing login styling
import { apiCall } from "../api/apiUtil";

const VendorLoginPage = () => {
    const resendTime = 10;
    const maximumAttempt = 1;

    const [loginType, setLoginType] = useState('vendor'); // 'vendor' or 'auditor'
    const [vendorCode, setVendorCode] = useState("");
    const [vendorPan, setVendorPan] = useState("");
    const [validvendor, setValidVendor] = useState(false);
    const [otp, setOtp] = useState("");
    const [timer, setTimer] = useState(resendTime); // 2 minutes
    const [resendDisabled, setResendDisabled] = useState(true);
    const [resendButtonClass, setResendButtonClass] = useState("reset-button-disabled");
    const [globalCode, setGlobalCode] = useState("");
    const [password, setPassword] = useState("");
    const [resendAttempts, setResendAttempts] = useState(0);
    const navigate = useNavigate();

    useEffect(() => {
        let interval;
        if (validvendor && resendDisabled) {
            interval = setInterval(() => {
                setTimer((prevTimer) => {
                    if (prevTimer <= 1) {
                        clearInterval(interval);
                        setResendButtonClass("reset-button");
                        setResendDisabled(false);
                        return 0;
                    }
                    return prevTimer - 1;
                });
            }, 1000);
        }
        return () => {
            if (interval) {
                clearInterval(interval);
            }
        };
    }, [validvendor, resendDisabled]);

    const getOtp = () => {
        console.log("Vendor Login:", { vendorCode, vendorPan });
        apiCall("/Vendor/GetVendorOtp", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ vendorCode, vendorPan }),
        })
        .then(data => {
            if (data.success) {
                setValidVendor(true);
            } else {
                alert(data.message);
            }
        })
        .catch(err => {
            console.error("Vendor Login Error:", err);
            alert("An error occurred during login.");
        });
    };

    const verifyOtp = (e) => {
        e.preventDefault();
        // TODO: Implement Vendor Login API call
        console.log("Vendor Login:", { vendorCode, otp });
        // alert("Vendor login not yet implemented.");
        // Example API call structure:
        apiCall("/Vendor/VerifyVendorOtp", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ vendorCode, otp }),
        })
        .then(data => {
            if (data.success) {
                // Store session info and navigate                
                sessionStorage.setItem("loginType", "Vendor");
                sessionStorage.setItem("vendorCode", data?.vendorCode);
                sessionStorage.setItem("vendorName", data?.vendorName);
                sessionStorage.setItem("orgUnit", data?.orgUnit);
                navigate("/vendor-dashboard");
            } else {
                alert(data.message);
            }
        })
        .catch(err => {
            console.error("Vendor Login Error:", err);
            alert("An error occurred during login.");
        });
    };

    const handleGetOtp = (e) => {
        e.preventDefault();
        setResendDisabled(true);
        setResendButtonClass("reset-button-disabled");
        setTimer(resendTime);
        setResendAttempts(0);
        // TODO: call api to get otp
        getOtp();
    };

    const handleResendOtp = (e) => {
        e.preventDefault();
        if (resendAttempts < maximumAttempt) {
            setTimer(resendTime);
            setResendDisabled(true);
            setResendButtonClass("reset-button-disabled");
            setResendAttempts(prev => prev + 1);
            // TODO: call api to resend otp
        }
        else {
            setResendButtonClass("reset-button-disabled");
            setResendDisabled(true);
        }
    };

    const handleAuditorSubmit = (e) => {
        e.preventDefault();
        // This can reuse the existing employee login logic
        apiCall("/EmployeeDetail/ValidateHrmsUser", {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ username: globalCode, password: password}),
		})
		.then((data) => {
			if (data.success) {
				sessionStorage.setItem("globalCode", data?.user?.globalCode);
                // ... (set other session items as in the original LoginPage)
				navigate("/auditor-dashboard"); // Navigate to a new auditor-specific dashboard
			} else {
				alert(data.message + " " + data.details);
			}
		})
		.catch((err) => {
			alert(err);
			console.error("Error:", err);
		});
    };

    const renderVendorForm = () => (
        <form>
            <h4 className="text-white">Vendor Login</h4>
            <hr className="border-secondary my-3" />
            <div className="form-group text-white">
                <label htmlFor="vendorCode">Vendor Code:</label>
                <input type="text" id="vendorCode" value={vendorCode} onChange={(e) => setVendorCode(e.target.value)} placeholder="Enter Vendor Code" required />
            </div>
            {
                !validvendor && (
                    <div className="form-group panNo">
                        {/* <label htmlFor="pan">Last 4 Character of PAN:</label>
                        <input type="password" id="pan" value={vendorPan} onChange={(e) => setVendorPan(e.target.value)} placeholder="Last 4 Character of PAN" required />
                        <br /><br />*/}
                        <button type="button" className="login-button" onClick={handleGetOtp}>
                            Get OTP
                        </button>
                    </div>
                )
            }
            {
                validvendor && (
                    <div className="form-group otp">
                        <label htmlFor="otp">OTP:</label>
                        <input type="password" id="otp" value={otp} onChange={(e) => setOtp(e.target.value)} placeholder="Enter OTP" required />
                        <br />
                        <br />                        
                        <button type="button" className="timer-button" disabled>
                            {`${String(Math.floor(timer / 60)).padStart(2, '0')}:${String(timer % 60).padStart(2, '0')}`}
                        </button>
                        &nbsp;&nbsp;
                        <button type="button" className={resendButtonClass} onClick={handleResendOtp} disabled={resendDisabled}>
                            {resendAttempts >= maximumAttempt ? "Max attempts reached" : "Resend OTP"}
                        </button>
                        <br /><br />
                        <button type="button" className="login-button" onClick={verifyOtp}>
                            Validate OTP
                        </button>
                    </div>
                )
            }
        </form>
    );

    const renderAuditorForm = () => (
        <form>
            <h4 className="text-white">Employee Login</h4>
            <hr className="border-secondary my-3" />
            {/* <div className="form-group text-white">
                <label htmlFor="globalCode">Global Code:</label>
                <input type="text" id="globalCode" value={globalCode} onChange={(e) => setGlobalCode(e.target.value)} placeholder="Enter Global Code" required />
            </div>
            <div className="form-group">
                <label htmlFor="password">Password:</label>
                <input type="password" id="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Enter your password" required />
            </div>
            <button type="submit" className="login-button">
                Login
            </button> */}
            <div className="form-group">
                <div className="g_id_signin" id="signInDiv" data-type="standard"></div>
            </div>
        </form>
    );

    return (
        <div className="login-container bg-dark">
			<div className="vendor-login-form">
                <div className="vendor-login-form-header">
                    <h4 className="text-white">Login To</h4>
                    <h5>Vendor Compliance System</h5>
                    <hr className="border-secondary my-3" />
                </div>
                <div className="vendor-login-form-body">
                    <div className="vendor-login-form-body-item">
                        {renderVendorForm()}
                    </div>
                    <div className="vendor-login-form-body-item-noborder">
                        {renderAuditorForm()}
                    </div>
                </div>
                {/* <div className="login-toggle-buttons">
                    Change User Type &nbsp;
                    <button type="button" onClick={() => setLoginType('vendor')} className={loginType === 'vendor' ? 'active' : ''}>Vendor</button>
                    <button type="button" onClick={() => setLoginType('auditor')} className={loginType === 'auditor' ? 'active' : ''}>Auditor</button>
                </div> */}
			</div>
		</div>
        // <div className="login-container bg-dark">
        //     <div className="login-toggle-buttons">
        //         <button onClick={() => setLoginType('vendor')} className={loginType === 'vendor' ? 'active' : ''}>Vendor</button>
        //         <button onClick={() => setLoginType('auditor')} className={loginType === 'auditor' ? 'active' : ''}>Auditor</button>
        //     </div>
        //     {loginType === 'vendor' ? renderVendorForm() : renderAuditorForm()}
        // </div>
    );
};

export default VendorLoginPage;
